exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".src-components-shared-LabeledNumericInput-label{margin-left:10px;word-wrap:break-word}.src-components-shared-LabeledNumericInput-error{color:#dc3545;font-size:80%}", ""]);

// exports
exports.locals = {
	"label": "src-components-shared-LabeledNumericInput-label",
	"error": "src-components-shared-LabeledNumericInput-error"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/shared/LabeledNumericInput/styles.scss
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/shared/LabeledNumericInput/styles.scss
// module chunks = 1